<template>
  <div>
    <v-chip
      label
      depressed
      small
      v-if="params && params.data && params.data.priority"
      :class="getSupportPriorityClass(params.data.priority)"
    >
      {{ params.data.verbose_priority }}
    </v-chip>
  </div>
</template>
  <script>
import { getSupportPriorityClass } from "@/utils/functions";
export default {
  data() {
    return {
      getSupportPriorityClass,
    };
  },
};
</script>
  